import { Toast } from '@components/Toast/Toast';
import CloseIcon from '@mui/icons-material/Close';
import Replay from '@mui/icons-material/Replay';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { VideoMenuButton } from '@pages/Library/components/MediaCard/components/VideoMenuButton';
import { useLibraryFolder } from '@stores/Library/LibraryFolder';
import { observer } from 'mobx-react';
import { toast } from 'sonner';
import css from '../LibraryContentMediaTable.module.scss';
import { renderWithUploadingCheck } from './cellUtils';
import { CellProps } from './types';

export const MenuCell = observer(({ media, onUploadClear }: CellProps) => {
  const folder = useLibraryFolder();
  const library = folder.library;
  const isModifiable = !library?.isReadOnly;
  const isErrored = media.status === 'errored';

  const handleRetry = async () => {
    if (media.libraryId) {
      // Remove from selection when retry starts
      folder.videoSelection.deselectItems([media._id]);
      const result = await folder.retryMedia(media.libraryId, media._id);
      if ('error' in result) {
        toast.custom(
          (t) => (
            <Toast
              id={t}
              header="Media retry failed"
              description={result.message}
              variant="error"
            />
          ),
          {
            duration: 10000,
          },
        );
      } else {
        folder.refreshMediaById(media._id);
      }
    }
  };

  return renderWithUploadingCheck(
    media,
    () => (
      <div className={css.menuCell}>
        {isErrored ? (
          <Tooltip title="Retry processing" placement="top" arrow>
            <IconButton size="small" onClick={handleRetry} className={css.retryButton}>
              <Replay />
            </IconButton>
          </Tooltip>
        ) : (
          <VideoMenuButton media={media} isModifiable={isModifiable} iconVariant="vertical" />
        )}
      </div>
    ),
    <div className={css.menuCell}>
      <Tooltip title="Cancel upload" placement="top" arrow>
        <IconButton size="small" onClickCapture={onUploadClear}>
          <CloseIcon />
        </IconButton>
      </Tooltip>
    </div>,
  );
});
